module.exports = __webpack_public_path__ + "img/hc_pro_ten_16.06cc8e8f.jpg";